"use client";
import React from "react";
import { motion } from "framer-motion";
import { Caveat } from "next/font/google";
import Image from "next/image";

const caveat = Caveat({ subsets: ["latin"], weight: ["400", "700"], display: "swap" });

export default function IndustrySecureDocs({ section }) {
  return (
    <section className="py-24 px-6 sm:px-12 lg:px-24 relative overflow-hidden">
      <div className="container mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">


          {/* Text Column */}
          <motion.div
            className="space-y-10 order-2 md:order-1"
          >
            <h2 className={`text-6xl md:text-8xl font-bold text-white leading-[1.1] ${caveat.className}`}>
              <span className="relative">
                Secure
                {/* Scribble Underline from SS */}
                <svg className="absolute -bottom-2 left-0 w-full h-4 text-[#f1833b]" preserveAspectRatio="none" viewBox="0 0 100 20">
                  <path d="M0,10 Q25,0 50,10 T100,10" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
                </svg>
              </span> document workspace
            </h2>

            <div className="space-y-8">
              {section.subtext.includes("workspace,") && section.subtext.includes("eSign") ? (
                <>
                  <p className="text-xl text-gray-300 leading-relaxed max-w-lg">
                    <strong className="text-white font-bold">Each project gets its own document workspace,</strong>
                    {section.subtext.split("workspace,")[1].split("Odoo's eSign")[0]}
                  </p>
                  <p className="text-xl text-gray-300 leading-relaxed max-w-lg">
                    <strong className="text-white font-bold">Odoo's eSign</strong>
                    {section.subtext.split("eSign")[1]}
                  </p>
                </>
              ) : (
                <p className="text-xl text-gray-300 leading-relaxed max-w-lg">
                  {section.subtext}
                </p>
              )}
            </div>

            
          </motion.div>

          {/* Image Column */}
          <motion.div
            className="relative order-1 md:order-2"
          >
            {/* Background Circle */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-white/5 rounded-full -z-10" />

            {/* Blue Rays/Sparkles from SS */}
            <div className="absolute -top-10 -left-10 w-24 h-24 z-20">
              <svg viewBox="0 0 100 100" className="w-full h-full text-[#f1833b]">
                <path d="M10,50 L30,50 M20,20 L35,35 M50,10 L50,30" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
              </svg>
            </div>

            <div className="rounded-2xl overflow-hidden shadow-2xl relative z-10 border border-white/10 bg-white/5">
              <Image 
                src={section.image} 
                width={650}
                height={450}
                sizes="(max-width: 1024px) 100vw, 50vw"
                className="w-full h-auto object-contain" 
                alt="Secure Document Workspace Mockup" 
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
